import { ApiService } from './api.services';
import { BaseService } from 'app/core/base.service';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { TermoTipoRenda } from '../models/TermoTipoRenda.model';
import { ViewModelFiltraProcesso } from '../models/ViewModelFiltraProcesso.model';
import { ViewModelAtualizarConfig } from '../models/viewModelAtualizarConfig.model';

export class WebTempTermoTipoRendaService extends ApiService implements BaseService<TermoTipoRenda>{

    private strAction = 'api/WebTempTermoTipoRenda';

    constructor(
        httpClient: HttpClient,
        private route: Router) {
        super(httpClient, route);
    }

    retornarConfig(): Observable<ViewModelAtualizarConfig> {
        return this.get<ViewModelAtualizarConfig>(this.strAction + `/RetornarConfig`);
    }

    Atualizar(viewModelAtualizarConfig: ViewModelAtualizarConfig): Observable<void> {
        return this.post<void>(this.strAction + `/AtualizarConfig`, viewModelAtualizarConfig);
    }


    getAll(): Observable<TermoTipoRenda[]> {
        return this.get<TermoTipoRenda[]>(this.strAction + `/GetAll`);
    }

    deleteById(idTermo: number) {
        return this.post(this.strAction + `/DeleteById?id=${idTermo}`);
    }

    Post(TermoTipoRenda: TermoTipoRenda): Observable<TermoTipoRenda[]> {
        return this.post<TermoTipoRenda[]>(this.strAction + `/Criar`, TermoTipoRenda);
    }

    getById(id: number): Observable<TermoTipoRenda> {
        return this.get<TermoTipoRenda>(this.strAction + `/GetById/${id}`);
    }


    PostFiltroTermoTipoRenda(viewModelFiltraProcesso: ViewModelFiltraProcesso): Observable<TermoTipoRenda[]> {
        return this.post<TermoTipoRenda[]>(this.strAction + `/PostFiltroTermoTipoRenda`, viewModelFiltraProcesso);
    }


    getByCpf(cpf: string): Observable<TermoTipoRenda[]> {
        return this.get<TermoTipoRenda[]>(this.strAction + `/GetByCpf?nrCpf=${cpf}`);
    }

    Put(TermoTipoRenda: TermoTipoRenda): Observable<TermoTipoRenda> {
        return this.post<TermoTipoRenda>(this.strAction + `/Put`, TermoTipoRenda);
    }



}